module.exports = __webpack_public_path__ + "img/index-solutions-embed-hover.dc7dc266.png";